import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
